import Dashboard from "../features/portal/dashboard/Dashboard";
import dashboardIcon from "assets/img/dashboard-icon.png";
import Role from "features/portal/role/Role";
import roleIcon from "assets/img/role-icon.png";
import userIcon from "assets/img/user-icon.png";
import settingsIcon from "assets/img/settings-icon.png";
import supportIcon from "assets/img/support-icon.png";
import reportIcon from "assets/img/report-icon.png";
import Settings from "features/settings/Settings";
import { useHasPermission } from "hooks/useHasPermission";
import Holidays from "features/portal/holidays/Holidays";
import PublishHoliday from "features/portal/holidays/PublishHoliday";
import CreateHoliday from "features/portal/holidays/CreateHoliday";
import holidayIcon from "assets/img/calendar-icon.png";
import MyDetails from "features/portal/MeSection/MyDocuments/MyDetails";
import ApprovedCandidateList from "features/portal/candidate/ApprovedCandidateList";
import policiesIcon from "assets/img/policy.png";
import Policies from "features/portal/Policies/index";
import Profile from "features/portal/MeSection/MyDocuments/Profile";
import Faq from "features/portal/faq/Faq";
import Post from "features/portal/post/Post";
import Leaves from "features/portal/leaves/Leaves";
import ApplyLeave from "features/portal/leaves/ApplyLeave";
import AssetRequestForm from "features/portal/assets/AssetRequestForm";
import Events from "features/portal/events/Events";
import PermissionUserList from "features/portal/permission/PermissionUserList";
import Candidate from "features/portal/candidate/Candidate";
import EmployeePage from "features/portal/employee/EmployeePage";
import Announcements from "features/portal/Announcements/index";
import announcementsIcon from "assets/img/announcement-icon.png";
import ReportPage from "features/portal/reports/ReportPage";
import ExistingEmpTable from "features/portal/existingEmployee/ExistingEmpTable";

import EmployeeTicketPage from "features/portal/support/employee/EmployeeTicketPage";
import CreateTicketPage from "features/portal/support/employee/CreateTicketPage";
import HrAllTicketPage from "features/portal/support/hr/HRTicketDashboard.js";
import Departments from "features/portal/Departments";
import Designations from "features/portal/Designation";

// Function to generate dashboard routes dynamically
const useDashboardRoutes = () => {
  const canViewRole = useHasPermission("Role-view");
  const canViewCandidate = useHasPermission("Candidate-view");
  const canViewEmployee = useHasPermission("Employee-view");
  const canViewSetting = useHasPermission("Settings-view");
  const canViewConvertToEmp = useHasPermission("Convert Employee-view");
  const canViewPolicy = useHasPermission("Policies-view");
  const canViewAnnouncement = useHasPermission("Announcements-view");
  const canViewSupport = useHasPermission("Support-view");
  const canViewExportCandidate = useHasPermission("Export Employee Data-view");
  const canViewExistingEmployee = useHasPermission("Existing Employee-view");
  const canManageHoliday = useHasPermission("Holiday-manage");
  const canManageHolidayPublish = useHasPermission("Holiday-Publish-view");

  const canViewDepartments = useHasPermission("Department-view");
  const canViewDesignations = useHasPermission("Designation-view");
  const year = new Date().getFullYear()

  return [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
      icon: dashboardIcon,
      component: Dashboard,
      inSidebar: true,
      permissionKey: null,
    },
    {
      path: "/admin/role",
      name: "Roles & Permissions",
      icon: roleIcon,
      component: Role,
      inSidebar: canViewRole,
      permissionKey: "Role-view",
    },
    {
      name: "Resources",
      icon: userIcon,
      inSidebar: canViewCandidate || canViewEmployee || canViewConvertToEmp,
      children: [
        {
          path: "/admin/candidate",
          name: "Candidates",
          component: Candidate,
          inSidebar: canViewCandidate,
          permissionKey: "Candidate-view",
        },
        {
          path: "/admin/convert",
          name: "Convert To Emp.",
          component: ApprovedCandidateList,
          inSidebar: canViewConvertToEmp,
          permissionKey: "Convert Employee-view",
        },
        {
          path: "/admin/employee",
          name: "Employees",
          component: EmployeePage,
          inSidebar: canViewEmployee,
          permissionKey: "Employee-view",
        },
        {
          path: "/admin/existing-employee",
          name: "Existing Employees",
          component: ExistingEmpTable,
          inSidebar: canViewExistingEmployee,
          permissionKey: "Existing Employee-view",
        },
      ],
    },
    {
      name: "Policies",
      path: "/admin/policies",
      component: Policies,
      icon: policiesIcon,
      inSidebar: canViewPolicy,
      permissionKey: "Policies-view",
    },
    {
      name: "Holidays",
      path: "/admin/holidays",
      component: Holidays,
      icon: holidayIcon,
      inSidebar: !canManageHoliday,
      permissionKey: null,
    },
    {
      name: "Holidays",
      icon: holidayIcon,
      inSidebar: canManageHoliday,
      children: [
        {
          path: "/admin/holidays",
          name: "Holidays",
          component: Holidays,
          inSidebar: true,
          permissionKey: null,
        },
        {
          path: "/admin/holidays-create",
          name: "Create Holidays",
          component: CreateHoliday,
          inSidebar: canManageHoliday,
          permissionKey: "Holiday-manage",
        },
        {
          //path: `/admin/holidays-publish/${year}`,
          path: `/admin/holidays-publish`,
          name: "Calendar List",
          component: PublishHoliday,
          inSidebar: canManageHoliday,
          permissionKey: "Holiday-manage",
        },
      ],
    },
    {
      name: "Announcements",
      path: "/admin/announcements",
      component: Announcements,
      icon: announcementsIcon,
      inSidebar: canViewAnnouncement,
      permissionKey: "Announcements-view",
    },
    {
      name: "My Profile",
      path: "/admin/my-details",
      component: MyDetails,
      icon: userIcon,
      inSidebar: true,
      permissionKey: null,
    },
    {
      path: "/admin/report",
      name: "Report",
      icon: reportIcon,
      component: ReportPage,
      inSidebar: canViewExportCandidate,
      permissionKey: "Export Employee Data-view",
    },
    {
      name: "Support",
      icon: supportIcon,
      inSidebar: true,
      children: [
        {
          path: "/admin/support",
          name: "My Tickets",
          component: EmployeeTicketPage,
          inSidebar: true,
          permissionKey: null,
        },
        {
          path: "/admin/support/create-ticket",
          name: "Create Ticket",
          component: CreateTicketPage,
          inSidebar: true,
          permissionKey: null,
        },
        {
          path: "/admin/support/hr",
          name: "All Tickets",
          component: HrAllTicketPage,
          inSidebar: canViewSupport,
          permissionKey: "Support-view",
        }
      ]
    },
    {
      name: "Departmens",
      path: "/admin/departments",
      component: Departments,
      icon: announcementsIcon,
      inSidebar: canViewDepartments,
      permissionKey: "Department-view",
    },
    {
      name: "Designations",
      path: "/admin/designations",
      component: Designations,
      icon: announcementsIcon,
      inSidebar: canViewDesignations,
      permissionKey: "Designation-view",
    },
    {
      name: "Profile",
      path: "/admin/profile",
      component: Profile,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "FAQ",
      path: "/admin/faq",
      component: Faq,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "Post",
      path: "/admin/post",
      component: Post,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "Leaves",
      path: "/admin/leaves",
      component: Leaves,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "Apply Leave",
      path: "/admin/apply-leave",
      component: ApplyLeave,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "Asset Request Form",
      path: "/admin/assetrequest",
      component: AssetRequestForm,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "Policies",
      path: "/admin/policies",
      component: Policies,
      inSidebar: false,
      permissionKey: "Policies-view",
    },
    {
      name: "Events",
      path: "/admin/events",
      component: Events,
      inSidebar: false,
      permissionKey: null,
    },
    {
      name: "Permission List",
      path: "/admin/permission list",
      component: PermissionUserList,
      inSidebar: false,
      permissionKey: "Permission-view",
    },
    {
      path: "/admin/settings",
      name: "Settings",
      icon: settingsIcon,
      component: Settings,
      inSidebar: canViewSetting,
      permissionKey: "Settings-view",
    },
  ];
};
export default useDashboardRoutes;
